import * as React from 'react';
const SvgAppReview = (props) => (
  <svg
    width={145}
    height={108}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_1069_5287)">
      <path
        d="M90.2825 69.2692H55.2476C53.7538 69.2692 52.5444 68.0598 52.5444 66.5659V18.5132C52.5444 17.0194 53.7538 15.8101 55.2476 15.8101H90.2825C91.776 15.8101 92.9853 17.0194 92.9853 18.5132V66.5659C92.9853 68.0598 91.776 69.2692 90.2825 69.2692Z"
        fill="url(#paint0_linear_1069_5287)"
      />
    </g>
    <path
      d="M77.3178 56.3044H68.2122C67.1985 56.3044 66.3805 55.4863 66.3805 54.4726C66.3805 53.4589 67.1985 52.6409 68.2122 52.6409H77.3178C78.3312 52.6409 79.1497 53.4589 79.1497 54.4726C79.1497 55.4863 78.3312 56.3044 77.3178 56.3044Z"
      fill="#D5DDEA"
    />
    <path
      d="M81.4969 60.2703H64.0151C63.4816 60.2703 63.0548 59.8435 63.0548 59.3099C63.0548 58.7765 63.4816 58.3496 64.0151 58.3496H81.4969C82.0305 58.3496 82.4575 58.7765 82.4575 59.3099C82.4575 59.8257 82.0305 60.2703 81.4969 60.2703Z"
      fill="#D5DDEA"
    />
    <path
      d="M84.7161 34.8747C84.7161 38.4671 83.1332 41.686 80.6258 43.8735C78.5273 45.7053 75.7705 46.8079 72.765 46.8079C69.7595 46.8079 67.003 45.7052 64.9044 43.8557C62.3968 41.6683 60.8141 38.4493 60.8141 34.8569C60.8141 28.259 66.1671 22.906 72.765 22.906C79.3631 22.906 84.7161 28.2768 84.7161 34.8747Z"
      fill="#D9DEEA"
    />
    <path
      d="M80.6258 43.8735C78.5273 45.7052 75.7704 46.8078 72.7649 46.8078C69.7594 46.8078 67.0029 45.7052 64.9043 43.8557C65.7757 43.5177 66.914 43.0732 68.4433 42.4508C68.7991 42.3085 69.0658 42.0417 69.2258 41.7038C69.3148 41.5082 69.3504 41.3125 69.3504 41.0991V38.2359C69.297 38.1825 69.2615 38.1114 69.2258 38.0581C68.9769 37.6846 68.8168 37.2577 68.7634 36.8132L68.5145 36.6887C67.7854 36.8665 67.8387 36.084 67.6431 34.5724C67.5719 33.9499 67.6608 33.8254 67.9454 33.7187L68.1766 33.3986C66.7539 30.1975 67.4653 28.1878 68.8702 27.4765C68.4078 26.4628 68.3722 26.0894 68.3722 26.0894C68.3722 26.0894 71.3599 26.5873 72.3736 26.3916C73.6719 26.1249 75.6815 26.445 76.4284 28.1701C77.6733 28.6502 78.1535 29.4506 78.2602 30.2864C78.3672 31.0689 78.1357 31.9225 77.9045 32.5806C77.8867 32.6339 77.869 32.6695 77.8511 32.705C77.8511 32.7228 77.8334 32.7406 77.8334 32.7584C77.7978 32.8473 77.78 32.9184 77.7445 32.9896C77.7267 33.0251 77.7267 33.0607 77.7089 33.0963C77.6911 33.1674 77.6555 33.2386 77.6378 33.2919C77.6378 33.3097 77.6378 33.3097 77.62 33.3275C77.6022 33.3808 77.5844 33.4342 77.5666 33.4875C77.5489 33.5587 77.531 33.612 77.5133 33.6653C77.531 33.6832 77.531 33.7187 77.5488 33.7365C77.7445 33.8254 77.8156 34.0033 77.7445 34.5546C77.5666 35.9951 77.6199 36.8665 76.873 36.6709L76.215 37.809C76.1972 37.9336 76.1795 38.0047 76.1617 38.0759C76.1439 38.2893 76.1439 38.7161 76.1439 41.0636C76.1439 41.3482 76.2328 41.6149 76.3751 41.8461C76.5352 42.095 76.7663 42.3085 77.0509 42.4329C77.0509 42.4329 77.0686 42.4329 77.0686 42.4508C78.616 43.1087 79.7539 43.5356 80.6258 43.8735Z"
      fill="white"
    />
    <path
      d="M77.531 33.6832C77.5844 33.3275 77.4244 32.8651 77.2998 32.5627C77.2821 32.5094 77.2465 32.4561 77.2287 32.4027C76.6596 31.2645 75.3792 30.7844 74.1698 30.7132C71.0754 30.5532 70.7731 31.14 69.8127 30.2508C70.115 30.6954 70.1329 31.4246 69.6705 32.3138C69.3504 32.9362 68.7279 33.2208 68.1588 33.3986C66.7361 30.1975 67.4474 28.1878 68.8524 27.4765C68.39 26.4628 68.3545 26.0894 68.3545 26.0894C68.3545 26.0894 71.3422 26.5873 72.3559 26.3916C73.6541 26.1249 75.6637 26.445 76.4107 28.1701C77.6556 28.6502 78.1357 29.4506 78.2424 30.2864C78.4559 31.6202 77.6733 33.0963 77.531 33.6832Z"
      fill="url(#paint1_linear_1069_5287)"
    />
    <path
      d="M76.3928 41.8819V42.4332H69.208V41.704C69.2969 41.5084 69.3326 41.3127 69.3326 41.0994V38.2361C69.2792 38.1827 69.2436 38.1116 69.208 38.0583V37.8804C69.3681 38.1472 69.5637 38.3784 69.7949 38.5918L72.0357 40.1746C72.5515 40.6192 73.3162 40.6192 73.8497 40.1923L75.9482 38.3072C76.0193 38.2538 76.0905 38.1827 76.1616 38.1116C76.1439 38.325 76.1439 38.7519 76.1439 41.0994C76.1794 41.3838 76.2505 41.6507 76.3928 41.8819Z"
      fill="url(#paint2_linear_1069_5287)"
    />
    <g filter="url(#filter1_d_1069_5287)">
      <path
        d="M42.692 60.9996H20.1595C18.6656 60.9996 17.4563 59.7904 17.4563 58.2965V26.783C17.4563 25.2892 18.6656 24.0798 20.1595 24.0798H42.692C44.1858 24.0798 45.3951 25.2892 45.3951 26.783V58.3143C45.3951 59.8081 44.1858 60.9996 42.692 60.9996Z"
        fill="url(#paint3_linear_1069_5287)"
      />
    </g>
    <path
      d="M34.5646 52.0541H28.2691C27.5755 52.0541 27.0063 51.4851 27.0063 50.7915C27.0063 50.0979 27.5755 49.5288 28.2691 49.5288H34.5646C35.2582 49.5288 35.8273 50.0979 35.8273 50.7915C35.8273 51.4851 35.2582 52.0541 34.5646 52.0541Z"
      fill="#D5DDEA"
    />
    <path
      d="M37.4634 54.7929H25.388C25.0145 54.7929 24.73 54.4905 24.73 54.1348C24.73 53.7614 25.0323 53.4768 25.388 53.4768H37.4634C37.8369 53.4768 38.1214 53.7792 38.1214 54.1348C38.1214 54.4905 37.8191 54.7929 37.4634 54.7929Z"
      fill="#D5DDEA"
    />
    <path
      d="M39.6686 37.2398C39.6686 39.7296 38.566 41.9526 36.841 43.4643C35.3826 44.727 33.4975 45.4916 31.4168 45.4916C29.336 45.4916 27.4332 44.727 25.9926 43.4643C24.2676 41.9526 23.1649 39.7296 23.1649 37.2398C23.1649 32.6871 26.864 28.988 31.4168 28.988C35.9696 28.988 39.6686 32.6871 39.6686 37.2398Z"
      fill="#D9DEEA"
    />
    <path
      d="M36.841 43.4652C35.3827 44.7279 33.4976 45.4926 31.4168 45.4926C29.3361 45.4926 27.4332 44.7279 25.9927 43.4652C26.5973 43.234 27.3798 42.9316 28.4291 42.487C28.6781 42.3803 28.8559 42.2025 28.9626 41.9713C29.0159 41.8468 29.0516 41.7045 29.0516 41.5445V39.5704C29.0159 39.5349 28.9804 39.4815 28.9626 39.4459C28.7848 39.197 28.6781 38.8946 28.6425 38.5923L28.4646 38.5034C27.9667 38.6279 28.0023 38.0766 27.86 37.0451C27.8067 36.6183 27.8778 36.5293 28.0556 36.4582L28.2157 36.2448C27.2376 34.0218 27.7355 32.6346 28.6958 32.1544C28.3757 31.4608 28.358 31.1941 28.358 31.1941C28.358 31.1941 30.4209 31.532 31.1323 31.4076C32.0393 31.2297 33.4087 31.4431 33.9244 32.6346C34.778 32.9726 35.1159 33.5239 35.187 34.0929C35.2582 34.6442 35.0981 35.2133 34.9558 35.6757C34.9381 35.7113 34.9381 35.7291 34.9203 35.7646C34.9203 35.7824 34.9026 35.7824 34.9026 35.8002C34.8847 35.8535 34.8669 35.9069 34.8492 35.9603C34.8314 35.978 34.8314 36.0136 34.8136 36.0314C34.7958 36.0847 34.778 36.1203 34.7603 36.1737V36.1915C34.7425 36.227 34.7246 36.2626 34.7246 36.2982C34.7069 36.3515 34.6891 36.3871 34.6891 36.4227C34.7069 36.4404 34.7069 36.4582 34.7069 36.476C34.8492 36.5471 34.8847 36.6539 34.8314 37.0273C34.7069 38.0232 34.7425 38.6279 34.2267 38.4856L33.7821 39.2859C33.7643 39.3748 33.7466 39.4104 33.7466 39.4815C33.7288 39.6238 33.7288 39.9261 33.7288 41.5445C33.7288 41.7401 33.7821 41.918 33.8889 42.078C33.9955 42.2558 34.1556 42.3981 34.3512 42.4693H34.369C35.4716 42.9317 36.2541 43.234 36.841 43.4652Z"
      fill="white"
    />
    <path
      d="M34.7247 36.4218C34.7603 36.1729 34.6535 35.8705 34.5646 35.6393C34.5469 35.6038 34.5291 35.5682 34.5113 35.5327C34.12 34.7502 33.2308 34.4123 32.3949 34.3767C30.2609 34.27 30.0474 34.679 29.3895 34.0566C29.6029 34.3767 29.6207 34.8568 29.3006 35.4793C29.0694 35.9061 28.6425 36.1017 28.2691 36.2262C27.2909 34.0032 27.7889 32.6161 28.7493 32.1359C28.4292 31.4423 28.4113 31.1755 28.4113 31.1755C28.4113 31.1755 30.4743 31.5135 31.1857 31.3889C32.0926 31.2111 33.462 31.4245 33.9778 32.6161C34.8314 32.9539 35.1693 33.5053 35.2405 34.0743C35.3471 34.9991 34.8136 36.0128 34.7247 36.4218Z"
      fill="url(#paint4_linear_1069_5287)"
    />
    <path
      d="M33.9422 42.0949V42.4861H28.9803V41.9704C29.0337 41.8459 29.0693 41.7036 29.0693 41.5436V39.5696C29.0337 39.5339 28.9982 39.4807 28.9803 39.445V39.3384C29.0871 39.5162 29.2294 39.694 29.3894 39.8185L30.9366 40.9034C31.2923 41.2057 31.8258 41.2235 32.1993 40.9211L33.6576 39.6229C33.711 39.5873 33.7643 39.5339 33.7999 39.4807C33.7821 39.6229 33.7821 39.9252 33.7821 41.5436C33.7821 41.7392 33.8354 41.9348 33.9422 42.0949Z"
      fill="url(#paint5_linear_1069_5287)"
    />
    <g filter="url(#filter2_d_1069_5287)">
      <path
        d="M124.837 60.9996H102.304C100.81 60.9996 99.6008 59.7904 99.6008 58.2965V26.783C99.6008 25.2892 100.81 24.0798 102.304 24.0798H124.837C126.33 24.0798 127.54 25.2892 127.54 26.783V58.3143C127.54 59.8081 126.33 60.9996 124.837 60.9996Z"
        fill="url(#paint6_linear_1069_5287)"
      />
    </g>
    <path
      d="M116.71 52.0541H110.414C109.721 52.0541 109.152 51.4851 109.152 50.7915C109.152 50.0979 109.721 49.5288 110.414 49.5288H116.71C117.403 49.5288 117.973 50.0979 117.973 50.7915C117.99 51.4851 117.421 52.0541 116.71 52.0541Z"
      fill="#D5DDEA"
    />
    <path
      d="M119.608 54.7929H107.533C107.159 54.7929 106.875 54.4905 106.875 54.1348C106.875 53.7614 107.177 53.4768 107.533 53.4768H119.608C119.982 53.4768 120.266 53.7792 120.266 54.1348C120.266 54.4905 119.982 54.7929 119.608 54.7929Z"
      fill="#D5DDEA"
    />
    <path
      d="M121.831 37.2398C121.831 39.7296 120.729 41.9526 119.004 43.4643C117.546 44.727 115.661 45.4916 113.579 45.4916C111.499 45.4916 109.596 44.727 108.155 43.4643C106.43 41.9526 105.327 39.7296 105.327 37.2398C105.327 32.6871 109.027 28.988 113.579 28.988C118.133 28.988 121.831 32.6871 121.831 37.2398Z"
      fill="#D9DEEA"
    />
    <path
      d="M119.004 43.4652C117.546 44.7279 115.661 45.4926 113.579 45.4926C111.499 45.4926 109.596 44.7279 108.155 43.4652C108.76 43.234 109.543 42.9316 110.592 42.487C110.841 42.3803 111.019 42.2025 111.125 41.9713C111.179 41.8468 111.214 41.7045 111.214 41.5445V39.5704C111.179 39.5349 111.143 39.4815 111.125 39.4459C110.947 39.197 110.841 38.8946 110.805 38.5923L110.627 38.5034C110.13 38.6279 110.165 38.0766 110.023 37.0451C109.969 36.6183 110.041 36.5293 110.218 36.4582L110.378 36.2448C109.4 34.0218 109.898 32.6346 110.859 32.1544C110.538 31.4608 110.52 31.1941 110.52 31.1941C110.52 31.1941 112.584 31.532 113.295 31.4076C114.202 31.2297 115.571 31.4431 116.087 32.6346C116.941 32.9726 117.279 33.5239 117.349 34.0929C117.421 34.6442 117.261 35.2133 117.119 35.6757C117.101 35.7113 117.101 35.7291 117.083 35.7646C117.083 35.7824 117.065 35.7824 117.065 35.8002C117.047 35.8535 117.03 35.9069 117.012 35.9603C116.994 35.978 116.994 36.0136 116.977 36.0314C116.959 36.0847 116.941 36.1203 116.923 36.1737V36.1915C116.905 36.227 116.887 36.2626 116.887 36.2982C116.87 36.3515 116.852 36.3871 116.852 36.4227C116.87 36.4404 116.87 36.4582 116.87 36.476C117.012 36.5471 117.047 36.6539 116.994 37.0273C116.87 38.0232 116.905 38.6279 116.39 38.4856L115.945 39.2859C115.927 39.3748 115.909 39.4104 115.909 39.4815C115.891 39.6238 115.891 39.9261 115.891 41.5445C115.891 41.7401 115.945 41.918 116.051 42.078C116.158 42.2558 116.318 42.3981 116.514 42.4693H116.532C117.616 42.9317 118.399 43.234 119.004 43.4652Z"
      fill="white"
    />
    <path
      d="M116.87 36.4218C116.905 36.1729 116.799 35.8705 116.71 35.6393C116.692 35.6038 116.674 35.5682 116.657 35.5327C116.265 34.7502 115.376 34.4123 114.54 34.3767C112.406 34.27 112.193 34.679 111.534 34.0566C111.748 34.3767 111.766 34.8568 111.446 35.4793C111.214 35.9061 110.787 36.1017 110.414 36.2262C109.436 34.0032 109.934 32.6161 110.894 32.1359C110.574 31.4423 110.556 31.1755 110.556 31.1755C110.556 31.1755 112.619 31.5135 113.331 31.3889C114.238 31.2111 115.607 31.4245 116.123 32.6161C116.977 32.9539 117.314 33.5053 117.386 34.0743C117.492 34.9991 116.977 36.0128 116.87 36.4218Z"
      fill="url(#paint7_linear_1069_5287)"
    />
    <path
      d="M116.087 42.0949V42.4861H111.125V41.9704C111.179 41.8459 111.214 41.7036 111.214 41.5436V39.5696C111.179 39.5339 111.143 39.4807 111.125 39.445V39.3384C111.232 39.5162 111.374 39.694 111.534 39.8185L113.082 40.9034C113.437 41.2057 113.971 41.2235 114.345 40.9211L115.803 39.6229C115.856 39.5873 115.909 39.5339 115.945 39.4807C115.927 39.6229 115.927 39.9252 115.927 41.5436C115.927 41.7392 115.98 41.9348 116.087 42.0949Z"
      fill="url(#paint8_linear_1069_5287)"
    />
    <path
      d="M120.622 94.9142L98.1248 72.4347L103.282 67.2773L125.761 89.7747L120.622 94.9142Z"
      fill="#858B9B"
    />
    <path
      d="M131.826 106.207L114.575 88.956C113.135 87.5152 113.135 85.1679 114.575 83.7279C116.016 82.287 118.363 82.287 119.804 83.7279L137.054 100.978C138.495 102.419 138.495 104.766 137.054 106.207C135.614 107.647 133.266 107.647 131.826 106.207Z"
      fill="#858B9B"
    />
    <path
      d="M130.599 107.31L108.405 85.1146C107.889 84.599 107.889 83.7632 108.405 83.2296L114.078 77.5565C114.593 77.0407 115.429 77.0407 115.963 77.5565L138.157 99.7515C138.673 100.267 138.673 101.103 138.157 101.636L132.484 107.31C131.95 107.825 131.114 107.825 130.599 107.31Z"
      fill="url(#paint9_linear_1069_5287)"
    />
    <path
      d="M72.6583 0C49.1121 0 30.0298 19.0824 30.0298 42.6286C30.0298 66.157 49.1121 85.2575 72.6406 85.2575C96.1864 85.2575 115.269 66.1748 115.269 42.6286C115.269 19.0824 96.1864 0 72.6583 0ZM72.6583 77.361C53.7538 77.361 38.4416 61.7999 38.4416 42.6108C38.4416 23.4217 53.7538 7.87836 72.6583 7.87836C91.5625 7.87836 106.875 23.4395 106.875 42.6286C106.875 61.8176 91.5453 77.361 72.6583 77.361Z"
      fill="url(#paint10_linear_1069_5287)"
    />
    <defs>
      <filter
        id="filter0_d_1069_5287"
        x={35.2794}
        y={7.17752}
        width={74.9711}
        height={87.9894}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={8.63254} />
        <feGaussianBlur stdDeviation={8.63254} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1069_5287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1069_5287"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1069_5287"
        x={0.191219}
        y={15.4473}
        width={62.469}
        height={71.4501}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={8.63254} />
        <feGaussianBlur stdDeviation={8.63254} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1069_5287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1069_5287"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_1069_5287"
        x={82.3358}
        y={15.4473}
        width={62.469}
        height={71.4501}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={8.63254} />
        <feGaussianBlur stdDeviation={8.63254} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1069_5287"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1069_5287"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1069_5287"
        x1={72.7518}
        y1={14.5735}
        x2={72.7518}
        y2={69.8454}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1069_5287"
        x1={67.3774}
        y1={29.887}
        x2={78.281}
        y2={29.887}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1069_5287"
        x1={72.8026}
        y1={42.4609}
        x2={72.8026}
        y2={39.9528}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#E2E5EC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1069_5287"
        x1={31.4166}
        y1={23.2258}
        x2={31.4166}
        y2={61.3977}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1069_5287"
        x1={27.7344}
        y1={33.7993}
        x2={35.2558}
        y2={33.7993}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1069_5287"
        x1={31.4628}
        y1={42.5053}
        x2={31.4628}
        y2={40.7712}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#E2E5EC" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1069_5287"
        x1={113.561}
        y1={23.2258}
        x2={113.561}
        y2={61.3977}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1069_5287"
        x1={109.879}
        y1={33.7993}
        x2={117.401}
        y2={33.7993}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1069_5287"
        x1={113.608}
        y1={42.5053}
        x2={113.608}
        y2={40.7712}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#E2E5EC" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1069_5287"
        x1={108.004}
        y1={92.4366}
        x2={138.549}
        y2={92.4366}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1069_5287"
        x1={29.9907}
        y1={42.6378}
        x2={115.285}
        y2={42.6378}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAppReview;
